import React from "react"

export const GoogleLogo = ({ className = 'w-[51px] h-auto mt-[3px] inline-block align-middle' }: { className?: string; }) => {
    return <img src={'/google.png'} alt="google logo" className={className} />
}